import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const ANON_KEY = "flightplan_anon_token";
const LANG_KEY = "flightplan_lang";

export function getAnonToken() {
  return localStorage.getItem(ANON_KEY);
}
export function setAnonToken(t) {
  localStorage.setItem(ANON_KEY, t);
}
export function getLang() {
  return localStorage.getItem(LANG_KEY) || "it";
}
export function setLang(l) {
  localStorage.setItem(LANG_KEY, l);
}

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = getAnonToken();
  if (t) config.headers["X-Anon-Token"] = t;
  return config;
});

export async function ensureAnonToken() {
  let t = getAnonToken();
  if (!t) {
    const res = await api.post("/anon/session");
    t = res.data.anon_token;
    setAnonToken(t);
  }
  return t;
}
